import { useContext } from "react";
import { UserDataApiContext } from "src/user-data/UserDataProvider.tsx";

export const useUserDataApi = () => {
  const context = useContext(UserDataApiContext);
  if (!context) {
    throw new Error("useUserDataApi must be used within UserDataApiProvider");
  }
  return context;
};
